import { Box, Button, Link, Step, StepLabel, Stepper } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import SlidingPanel from "react-sliding-side-panel";
import CloseIcon from "@mui/icons-material/Close";
// Defining Props interface for component
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const ClaimPopup: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const steps = ["Active", "Inprogress", "Pending"];

  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        // backdropClicked={() => value_update(attrName, false)}
      >
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid xs={10} className="headingTitle">
              <h3>
                <span>Claim Detail</span>
              </h3>
            </Grid>
            <Grid xs={2} textAlign="right">
              <Link
                className="closeIcon"
                onClick={() => {
                  value_update(attrName, false);
                }}
              >
                <CloseIcon />
              </Link>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <Box className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Stepper activeStep={1} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                {/* <ul className="status_data">
                  <li>
                    <div className="circle">
                      <span className="active">Active</span>
                    </div>
                  </li>
                  <li>
                    <div className="circle">
                      <span className="pending">Pending</span>
                    </div>
                  </li>
                  <li>
                    <div className="circle">
                      <span className="rejected">Rejected</span>
                    </div>
                  </li>
                  <li>
                    <div className="circle">
                      <span className="inprogress">Inprogress</span>
                    </div>
                  </li>
                </ul> */}
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Policy Number <span>PROH89346794567454</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Admission Date <span>24/06/2023</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Reason for Hospitalisation{" "}
                  <span>
                    I am going for treatment for a stone located in my lower
                    ureter.
                  </span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Member Id
                  <span>EV 065 - Vikas Saini</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Client Id
                  <span>EV 005 - Evervent</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Policy Id
                  <span>PB152412- Group Health</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Hospital
                  <span>Fortis Hospital</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Country
                  <span>India</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  State
                  <span>UK</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  City
                  <span>Dehradun</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Department
                  <span>Engineering</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Discharge Date
                  <span>22-8-2023</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Illness Reason for Hospitalisation/Claim
                  <span>Illness Reason</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Requested Claim Amount
                  <span>₹ 10,000</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Paid Claim Amount
                  <span>₹ 10,000</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Outstanding Claim Amount
                  <span>₹ 10,000</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Transaction Id
                  <span>Zxabcd1234</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Bank Name
                  <span>SBI</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Branch Name
                  <span>Dehradun</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Remarks
                  <span>Lorem</span>
                </p>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </>
      </SlidingPanel>
    </>
  );
};

export default ClaimPopup;
